declare var alertify: any;
declare var Notification: any;

export default class MensajeAnterior {
	public static mensajeAnterior;
	public static referenciaMensaje: any;

	static asingarValorMensajeAnterior(mensaje:string) {
		if (mensaje == this.mensajeAnterior) {
			if (this.referenciaMensaje != null && this.referenciaMensaje != undefined) {
				this.referenciaMensaje.dismiss();
			}
		} 
		this.mensajeAnterior = mensaje;
	}
}

export function messages(): string {
	return 'messages';
}


const DuracionMensaje = (mensaje: string) => {
	// se deja de 4 segundos toda vez que se demoran mucho en desaparecer, el ingeniero fue el que dijo que 4 segundos
	// dCardenas
	const duracionOriginal = 4;
	var tiempoSugerido = mensaje.length / 10;
	if (duracionOriginal > tiempoSugerido) {
		return duracionOriginal;
	} else {
		return tiempoSugerido;
	}
}


export function MostrarMensaje(mensaje: string) {
	alertify.alert('Yéminus', mensaje);
}


export function MensajeError(mensaje: string, delay = 0) {
	MensajeAnterior.asingarValorMensajeAnterior(mensaje);

	if (delay == 0) {
		delay = DuracionMensaje(mensaje);
	}
	alertify.set('notifier', 'position', 'bottom-right');
	alertify.set('notifier', 'delay', delay);
	MensajeAnterior.referenciaMensaje = alertify.error(mensaje);
	alertify.set('notifier', 'delay', delay);
}


export function MensajeExito(mensaje: string, delay = 0) {
	MensajeAnterior.asingarValorMensajeAnterior(mensaje);
	if (delay == 0) {
		delay = DuracionMensaje(mensaje);
	}
	alertify.set('notifier', 'position', 'bottom-right');
	alertify.set('notifier', 'delay', delay);
	MensajeAnterior.referenciaMensaje = alertify.success(mensaje);
	alertify.set('notifier', 'delay', delay);
}


export function MensajeAdvertencia(mensaje: string, delay = 0) {
	MensajeAnterior.asingarValorMensajeAnterior(mensaje);
	if (delay == 0) {
		delay = DuracionMensaje(mensaje);
	}
	alertify.set('notifier', 'position', 'bottom-right');
	alertify.set('notifier', 'delay', delay);
	MensajeAnterior.referenciaMensaje = alertify.warning(mensaje);
	alertify.set('notifier', 'delay', delay);
}


export function MensajeNotificacion(mensaje: string, delay = 0) {
	MensajeAnterior.asingarValorMensajeAnterior(mensaje);
	if (delay == 0) {
		delay = DuracionMensaje(mensaje);
	}
	alertify.set('notifier', 'position', 'bottom-right');
	alertify.set('notifier', 'delay', delay);
	MensajeAnterior.referenciaMensaje = alertify.notify(mensaje);
	alertify.set('notifier', 'delay', delay);
}

/**
 * Alerta que se muestra abajo centrado
 * @author Bvelez
 */
export function MensajeCallout(mensaje: string, delay = 0): void {
	MensajeAnterior.asingarValorMensajeAnterior(mensaje);
	alertify.set('notifier', 'position', 'bottom-center');
	alertify.set('notifier', 'delay', delay);
	MensajeAnterior.referenciaMensaje = alertify.warning(mensaje);
}
/**
 * Alerta que se muestra abajo centrado
 * @author Bvelez
 */
export function CerrarAlertas(): void {
	alertify.dismissAll();
}


export function SystemNotify(message: string) {
	try {
		if (Notification) {
			if (Notification.permission === 'granted') {
				Notification.requestPermission((status: any) => {
					if (status === 'granted') {
						let options: any = {
							body: message,
							icon: 'assets/ng1/img/logoxs.png'
						};
						let audio: HTMLAudioElement | null = new Audio('assets/sounds/new-message.mp3');
						audio.play();
						let notif = new Notification('Notificación Yéminus', options);

						// limpia variables
						options = null;
						audio = null;
						notif = null;
					}
				});
			}
		}
	} catch (error) {
		console.log(`Ocurrió un error al mostrar las notificaciones del sistema`);
	}
}

/**
 * se agrega parametro para que no siempre se muestren las opciones de ok y cancel al confirmar un mensaje, se puede enviar por ejemplo si y no
 * Modificado jcastillo (20/01/2023)
 */
export function ConfirmarMensaje(mensaje: string, callBack: (data: boolean) => void, soloAceptar = false, opciones : {cancel: string, ok :string} = {cancel: 'Cancel', ok: 'Ok'}) {
	try {
		if (!soloAceptar) {
			alertify.confirm('Yéminus', mensaje, () => {
				callBack(true);
			},
				() => {
					callBack(false);
				}).set({ labels: opciones });
		} else {
			alertify.alert()
				.setting({
					title: ' ',
					message: mensaje,
					onok: callBack
				}).show();
		}
	} catch (error) {
		console.log(`Ocurrió un error al Confirmar mensaje`);
	}
}


export function PromesaConfirmarMensaje(mensaje: string): Promise<boolean> {
	return new Promise((resolve, reject) => {
		try {

			alertify
				.confirm('Yéminus', mensaje,
					() => {
						resolve(true);
					},
					() => {

						reject();
					});

		} catch (error) {
			console.log(`Ocurrió un error al Confirmar mensaje`);
		}
	})
}


export function IngresarValor(mensaje: string, mensajeCancelar: string, callBack: (data: any) => {}) {
	try {
		alertify.prompt('Yéminus', mensaje, ''
			, (_evt: any, value: any) => {
				let data: any = {
					valor: value,
					ok: true
				};
				callBack(data);
				data = null;
			}
			, () => {
				if (mensajeCancelar) {
					let data: any = {
						valor: '',
						ok: false
					};
					callBack(data);
					alertify.error(mensajeCancelar);
					data = null;
				}
			});

	} catch (e) {
		console.log(`Ocurrió un error al ingresar valor`);
	}

}

export function MensajeInformacion(icono: string, titulo: string, mensaje: string, tipo: string = 'success', tiempo: number = 5): void {
	var estructuraDelMensaje = `<div class="alert alert-${tipo} alert-dismissible">
                                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                                <h4><i class="icon ${icono}"></i> ${titulo} </h4>
                                ${mensaje}
                              </div>"`
	if (tiempo == 0) {
		tiempo = DuracionMensaje(mensaje);
	}
	alertify.set('notifier', 'position', 'top-center');
	switch (tipo) {
		case 'success':
			alertify.success(estructuraDelMensaje);
			break;

		default:
			break;
	}
	 

	alertify.set('notifier', 'position', 'top-center');
}